import React, { useMemo } from 'react';
import Icon, { IconType } from 'components/Icon';
import { Tooltip } from 'components/Widget/Tooltip';
import * as S from './styles';

interface ToolButtonProps {
	icon?: IconType;
	// Optional text label rendered next to the icon. Use for buttons whose
	// purpose isn't obvious from the icon alone.
	label?: string;
	onClick?: () => void;
	active?: boolean;
	selected?: boolean;
	disabled?: boolean;
	tooltip?: string;
	tooltipId?: string;
	children?: React.ReactNode;
}

const ToolButton = ({
	icon,
	label,
	onClick,
	active,
	selected,
	disabled,
	tooltip,
	tooltipId,
	children,
}: ToolButtonProps) => {
	const finalTooltipId = useMemo(() => {
		if (tooltipId) return tooltipId;
		if (tooltip) return `tool-button-tooltip-${Math.random().toString(36).substr(2, 9)}`;
		return undefined;
	}, [tooltipId, tooltip]);

	return (
		<>
			{tooltip && finalTooltipId && <Tooltip placement="bottom" id={finalTooltipId} />}
			<S.Base
				onClick={onClick}
				active={active}
				selected={selected}
				disabled={disabled}
				$hasLabel={!!label}
				data-tooltip-id={finalTooltipId}
				data-tooltip-content={tooltip}
			>
				{icon && <Icon type={icon} width={16} height={16} />}
				{label && <S.Label>{label}</S.Label>}
				{children}
			</S.Base>
		</>
	);
};

export default ToolButton;

